// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"273":"a5de35c7","363":"a5de35c7","494":"a5de35c7","648":"a5de35c7","803":"a5de35c7","841":"a5de35c7","857":"a5de35c7","997":"cfc096cf"}[chunkId] + ".chunk.css";
};